module.exports = __webpack_public_path__ + "static/media/lagos.7d97884b.svg";